import type { Paths, PathValue } from '@infinex/types';

/**
 * @example
 * setPath({ name: { first: 'Bilbo', last: 'Baggins' } }, 'name.first', 'John'); // { name: { first: 'John', last: 'Baggins' } }
 * setPath({ name: { first: 'Bilbo', last: 'Baggins' } }, 'name', { first: 'John', last: 'Smith' }); // { name: { first: 'John', last: 'Smith' } }
 */
export function setPath<
  Obj extends Record<string, unknown>,
  Path extends Paths<Obj>,
>(obj: Obj, path: Path, value: PathValue<Obj, Path> | undefined) {
  const parts = path.split('.');

  const clone = structuredClone(obj);
  let current: any = clone;

  for (let i = 0; i < parts.length - 1; i++) {
    const key = parts[i];
    if (!current[key] || typeof current[key] !== 'object') {
      current[key] = {};
    }
    current = current[key];
  }

  const lastKey = parts[parts.length - 1];
  if (value === undefined) {
    delete current[lastKey];
  } else {
    current[lastKey] = value;
  }
  return clone;
}
